import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Typography,
  CircularProgress,
  Paper,
  Box,
} from '@mui/material';
import { Receipt as ReceiptIcon } from '@mui/icons-material';
import { obtenerFacturasResumen } from '../../../actions/CobranzasAction';
import TResumenFacturas from '../TResumenFacturas';
export default function PanelResumenFacturas() {
  const [data, setData] = useState([]);
  const mounted = useRef(true);
  const [datosCargados, setDatosCargados] = useState(false);
  useEffect(() => {
    if (mounted.current) {
      obtenerFacturasResumen().then((response) => {
        if (response.status === 200) {
          setData(response.data);
          setDatosCargados(true);
        }
      });
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, []);
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header */}
      <Paper
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
          p: 3,
          mb: 3,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            right: -20,
            top: -20,
            opacity: 0.2,
          }}
        >
          <ReceiptIcon sx={{ fontSize: 120, transform: 'rotate(-15deg)' }} />
        </Box>
        <Box sx={{ position: 'relative' }}>
          <Typography
            variant="h4"
            fontWeight={700}
            color="white"
            sx={{ display: 'flex', alignItems: 'center', gap: 2 }}
          >
            <ReceiptIcon sx={{ fontSize: 40 }} />
            Resumen de Facturas a Cobrar
          </Typography>
        </Box>
      </Paper>

      {/* Content */}
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        {datosCargados ? (
          <TResumenFacturas rows={data} />
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 8,
              gap: 2,
            }}
          >
            <CircularProgress size={48} />
            <Typography variant="h6" color="text.secondary">
              Cargando resumen de facturas...
            </Typography>
          </Box>
        )}
      </Paper>
    </Container>
  );
}
